import React from 'react';
import { FileText, Phone } from 'lucide-react';
import { useDrawers } from '../../contexts/DrawerContext';
import { Button } from '../ui/Button';
export function FinalCTA() {
  const {
    openQuote,
    openUpload
  } = useDrawers();
  return <section className="bg-background px-5 py-8 md:px-6 md:py-12" data-id="element-259" data-mp="q9w62q2sb1zj">
      <div className="mx-auto max-w-7xl" data-id="element-260" data-mp="lb1mvn0wnbew">
        <div className="border-t-4 border-peach bg-ink px-6 py-8 text-cream md:px-10 md:py-10" data-id="element-261" data-mp="lc2x5pa3jtvk">
          <div className="max-w-2xl" data-id="element-262" data-mp="3treaenjclqv7">
            <p className="eyebrow text-peach" data-id="element-263" data-mp="3osa4q6vmub9m">before you sign</p>
            <h2 className="mt-3 font-serif text-3xl leading-tight text-cream md:text-[2.6rem]" data-id="element-264" data-mp="3opxc8zs90iib">
              Get clear on what the contract actually means.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-cream/75" data-id="element-265" data-mp="2k1v6e20znhx">
              Tell us about any auction, offer or signing deadline and the team
              will assess how quickly your matter needs to move.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-266" data-mp="35zppvtcrq6ot">
              <Button onClick={openUpload} variant="peach" size="lg" className="w-full sm:w-auto" data-id="element-267" data-mp="2zbplkormuqdi">
                <FileText className="h-5 w-5" data-id="element-268" data-mp="384j9tbp2503i" />
                Upload your contract
              </Button>
              <Button onClick={openQuote} size="lg" className="w-full bg-cream text-ink hover:bg-white sm:w-auto" data-id="element-269" data-mp="3d2uhbfrvqyik">
                Request a quote
              </Button>
            </div>

            <a href="tel:+61386172600" className="mt-6 inline-flex items-center gap-2 font-semibold text-cream/85 transition-colors hover:text-white" data-id="element-270" data-mp="2kh1kdmt9me3p">
              <Phone className="h-4 w-4" data-id="element-271" data-mp="2ub1opmgq3fbd" />
              Call (03) 8617 2600
            </a>
          </div>
        </div>
      </div>
    </section>;
}